import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ConfigService} from './config.service';
import {isPlatformBrowser} from '@angular/common';
import {Observable, first, map} from 'rxjs';
import {AuthStorageService, AuthToken} from '@spartacus/core';
import {HttpRequestOptions} from '../models/http-request-options.model';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {ICountrySelectorService} from '../interfaces/country-selector-service.interface';
import token from '../token/tokens';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class KymaService {
  private isIasActive: boolean = false;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    @Inject(token.services.COUNTRY_SELECTOR_SERVICE_PROVIDER)
    private countrySelectorService: ICountrySelectorService,
    private authStorageService: AuthStorageService,
    private configService: ConfigService,
  ) {
    // check if we are in token exchange mode and need to use UDEX gateway for API calls.
    if (isPlatformBrowser(this.platformId)) {
      this.isIasActive = window.sessionStorage.getItem('iasActiveFlag') === 'true';
    }
  }

  /**
   * Returns the url of the kyma service as configured in the environment.
   *
   * @param namespace name of the url in the kyma namespace
   */
  getUrl(namespace: string): string {
    const key = 'kyma.' + (this.isIasActive ? 'namespaceUdex' : 'namespace');
    return this.configService.getObject(key)[namespace];
  }

  /**
   * Prepare authorization headers for Kyma
   */
  prepareAuthConfig(): Observable<HttpRequestOptions> {
    const config: HttpRequestOptions = this.prepareHeaderConfig();
    return this.authStorageService.getToken().pipe(
      first(),
      map((token: AuthToken): HttpRequestOptions => {
        if (token.access_token) {
          config.headers = config.headers?.set(
            'authorization',
            `${token.token_type || 'Bearer'} ${token.access_token}`,
          );
          config.params = new HttpParams();
        }
        return config;
      }),
      untilDestroyed(this),
    );
  }

  /**
   * Prepare headers for kyma calls
   */
  prepareHeaderConfig = (): HttpRequestOptions => ({
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      country: this.countrySelectorService.getCurrentCountry().isocode || '',
    }),
  });
}
